import { logError } from ':support/utils/error-vitals/logging';

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

type LogMessage = {
  level: LogLevel;
  message: string;
  timestamp: string;
  context?: string;
  error?: unknown;
};

export function notifyError(
  message: string,
  context = 'support_nextjs_app_initialized',
  errorMessage?: unknown,
) {
  const logMessage: LogMessage = {
    level: 'warn',
    message,
    context,
    timestamp: new Date().toISOString(),
  };

  if (errorMessage) {
    logMessage.error = errorMessage;
  }

  logError(logMessage, { context });
}

export function handleSsrError(error: Error): void {
  if (process.env.NODE_ENV !== 'production') {
    // console.error(error);
  }
  logError(error, { context: 'nextJs_ssr_error' });
}

export function handleCsrError(error: Error): void {
  if (process.env.NODE_ENV !== 'production') {
    // console.error(error);
  }
  logError(error, { context: 'nextJs_csr_error' });
}

export function handleCookieError(error: Error): void {
  if (process.env.NODE_ENV !== 'production') {
    // console.error(error);
  }
  logError(error, { context: 'handle_error_cookie_provider' });
}
